import {
  SET_ALL,
  UPDATE_OFFER_DATA_BY_ID,
  UPDATE_BID_DATA_BY_ID,
  ADD_OFFER_TO_LIST,
  ADD_MESSAGE,
} from './mutation-types';

export default {
  [SET_ALL](state, data) {
    Object.assign(state, data);
    return state;
  },
  [UPDATE_OFFER_DATA_BY_ID](state, { id, data } = {}) {
    if (!id) return state.marketOfferList;
    const offer = state.marketOfferList.find(item => item.id === id);
    if (!offer) return state.marketOfferList;
    offer.$setAll(data);
    return state.marketOfferList;
  },
  [UPDATE_BID_DATA_BY_ID](state, { id, data } = {}) {
    if (!id) return state.marketUserBidList;
    const bid = state.marketUserBidList.find(item => item.id === id);
    if (!bid) return state.marketUserBidList;
    bid.$setAll(data);
    return state.marketUserBidList;
  },
  [ADD_OFFER_TO_LIST](state, offer) {
    state.marketOfferList = [offer, ...state.marketOfferList];
    return state.marketOfferList;
  },
  [ADD_MESSAGE](state, message) {
    state.marketMessages = state.marketMessages.concat(message);
    return state.marketMessages;
  },
};
